module.exports = __webpack_public_path__ + "static/media/Bb-penta-scale.a0bf9f0a.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/Bb-penta-scale.m4a
// module id = 348
// module chunks = 0